import React from 'react';
import { ApiContext, StateContext } from '../context.js';
function TabList(deps, props, ref) {
  var state = React.useContext(StateContext);
  var _deps = deps(React.useContext(ApiContext)),
    Tabs = _deps.Tabs,
    tablistPropsManager = _deps.tablistPropsManager;
  return /*#__PURE__*/React.createElement(Tabs, tablistPropsManager(ref, state));
}
export default TabList;